/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import t from "react";
import { Toolbar as c, Button as m } from "@progress/kendo-react-buttons";
const u = (o) => {
  const { activeView: l, toolbarItems: r, activeViewChange: a } = o, n = (e) => {
    a == null || a.call(null, e);
  };
  return /* @__PURE__ */ t.createElement("div", { className: "k-prompt-header" }, /* @__PURE__ */ t.createElement(c, { keyboardNavigation: !1, role: "toolbar", className: "k-toolbar-flat" }, r.map(
    (e) => t.isValidElement(e) ? e : /* @__PURE__ */ t.createElement(
      m,
      {
        key: e.name,
        className: l === e.name ? "k-selected" : "",
        size: "medium",
        themeColor: "primary",
        fillMode: "flat",
        rounded: "full",
        title: e.buttonText,
        svgIcon: e.buttonIcon,
        "aria-hidden": "true",
        onClick: () => n(e.name)
      },
      e.buttonText
    )
  )));
};
export {
  u as PromptHeader
};
